const prefix = 'SourcingProject';

export enum SourcingProjectField {
  ID = `${prefix}.id`,
  TITLE = `${prefix}.title`,
  STATUS = `${prefix}.status`,
  VARIANT = `${prefix}.variant`,
  STARTED_AT = `${prefix}.startedAt`,
  ESTIMATED_TOTAL_VALUE = `${prefix}.estimatedTotalValue`,
  COMMODITY_GROUP_ID = `${prefix}.commodityGroupId`,
  CURRENCY = `${prefix}.currency`,
  BUYER_ID = `${prefix}.buyerId`,
}

export interface SourcingProjectData {
  id: string;
  title?: string | null;
  status?: string | null;
  variant?: string | null;
  startedAt?: string | null;
  estimatedTotalValue?: number | null;
  buyerId?: string | null;
  commodityGroupId?: string | null;
  currency?: string | null;
}
